









































import { useConfigStore } from '@/store/config';
import { ContentLoader } from '@tencent/wphk-components-content-loader';
import { computed, defineComponent, toRefs, reactive, onMounted } from '@vue/composition-api';
import HeaderImage from './header-module/header-image.vue';


export default defineComponent({
  name: 'PageSkeleton',
  props: {},
  components: {
    ContentLoader,
    HeaderImage,
  },

  setup() {
    const { config } = toRefs(useConfigStore());
    let headerConfig = reactive({
      leftImgUrl: '',
      rightImgSmallUrl: config.value.commonConfig.actConfig.rightImageSmallUrl,
      top: '',
      leftImgHeight: '',
      headerHeight: '',
      rightImgHeight: '',
      rightImgBigOpacity: 100,
      rightImgSmallOpacity: 0,
    });
    const colorStyle = computed(() => {
      const { bgColor } = config.value.commonConfig.actConfig || {};
      return `background-color:${bgColor};`;
    });

    const calcDistance = ({ percentage = 0, originalSize, targetSize, isLength = true }: {
      percentage: any, originalSize: number, targetSize: number, isLength?: boolean
    }) => {
      const division = isLength ? 200 : 1;
      return (originalSize * (1 - percentage) + targetSize * percentage) / division;
    };

    const getStyle = (num, attr, unit = 'rem') => `${attr}:${num}${unit};`;
    const calcAllStyle = (percentage) => ({
      top: getStyle(calcDistance({ percentage, originalSize: -850, targetSize: -1010 }), 'top'),
      leftImgHeight: getStyle(calcDistance({ percentage, originalSize: 400, targetSize: 240 }), 'height'),
      headerHeight: getStyle(calcDistance({ percentage, originalSize: 400, targetSize: 240 }), 'height'),
      rightImgHeight: getStyle(calcDistance({ percentage, originalSize: 640, targetSize: 480 }), 'height'),
      rightImgBigOpacity: getStyle(calcDistance({ percentage: percentage >= 0.3 ? 1 : 0, originalSize: 1, targetSize: 0, isLength: false }), 'opacity', ''),
      rightImgSmallOpacity: getStyle(calcDistance({ percentage: 1, originalSize: 1, targetSize: 1, isLength: false }), 'opacity', ''),
    });
    onMounted(() => {
      headerConfig = Object.assign(headerConfig, calcAllStyle(1));
    });

    return { headerConfig, colorStyle, isShowBigHeader: true };
  },
});
